import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import useSWR from 'swr'

import { usePrevious } from '../hooks/usePrevious'
import { isTransactionFinished } from '../utils/transaction'

import TransactionContext from './TransactionContext'

const AppReload = function () {
  const router = useRouter()
  const [reloadQueued, setReloadQueued] = useState(false)
  const [timeoutId, setTimeoutId] = useState(undefined)
  const { currentTransactions } = useContext(TransactionContext)
  const appReloadInterval =
    process.env.NEXT_PUBLIC_AUTORELOAD_INTERVAL * 1000 * 60
  const { data: version } = useSWR(
    '/api/version',
    url => fetch(url).then(res => res.text()),
    {
      refreshInterval: appReloadInterval
    }
  )
  const previousVersion = usePrevious(version)

  const areNonFinalizedTransactions = currentTransactions.some(
    t => !isTransactionFinished(t)
  )

  useEffect(
    function () {
      if (!version || !previousVersion || version === previousVersion) {
        return
      }
      if (areNonFinalizedTransactions) {
        // Queue a reload, until tx are finished
        setReloadQueued(true)
        return
      }
      router.reload(window.location.pathname)
    },
    [previousVersion, version, areNonFinalizedTransactions, router]
  )

  useEffect(
    function () {
      if (areNonFinalizedTransactions || !reloadQueued) {
        return
      }
      setReloadQueued(false)
      // Wait 10 to reload. Do not clear timeout in hook cleanup
      // because the tx object are still updated once finalized.
      // As everything will be unmounted, it is easier to save the id
      // and use a separated cleanup effect that does not depends on the tx.
      setTimeoutId(
        setTimeout(() => router.reload(window.location.pathname), 10 * 1000)
      )
    },
    [setReloadQueued, reloadQueued, areNonFinalizedTransactions, router]
  )

  useEffect(
    function () {
      if (timeoutId) {
        return () => clearTimeout(timeoutId)
      }
      return undefined
    },
    [timeoutId]
  )

  return null
}

export default AppReload
